export const Logo = ({ size = 36, withText = true, testId = "tro-logo" }) => (
  <img
    src={`${process.env.PUBLIC_URL}/branding/${withText ? "tro-wordmark.png" : "tro-icon.png"}`}
    alt="TRO"
    width={withText ? size * 4 : size}
    height={withText ? (size * 4 * 133) / 406 : size}
    className="block max-w-full object-contain"
    style={{ width: withText ? size * 4 : size, height: "auto" }}
    data-testid={testId}
    draggable={false}
  />
);
